import React from 'react';
import '../../App.css';
import Footer from "../Footer";
import PDFViewer from '../PDFViewer';
import CardItem from '../CardItem';
import { useEffect } from 'react';

function Coder() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <> 
            <div className='coder-bg'>
                <h1 className="page-title">Coder (Age: 8-10 y/o)</h1>
                <div className="subprogramme-container">
                    <div className="kad__container">
                        <div className="cards__wrapper">
                            <ul className="cards__items">
                                <CardItem 
                                src="images/coder2.jpg"
                                text="Master advanced Scratch, mechanics, and machine learning with Wedo for a deeper understanding of technology."
                                label='Coder (8-10)'
                                path='/coder'
                                />
                            </ul>
                        </div>
                    </div>
                    <div className="subprogramme-pdf">
                        <PDFViewer path="pdf/Roblock-World-Program-Outline-Coder.pdf" />
                    </div>
                </div>
            </div>           
            <Footer />
        </>
    )
}

export default Coder
